import { useMediaQuery } from '@hover/blueprint/chakra';
import { breakpoints } from '@hover/blueprint/foundation';

/**
 * Returns true if media query is above tablet minimum but below desktop minimum
 */
const useIsTabletSize = (): boolean => {
  const mediaQueries = useMediaQuery([
    `(min-width: ${breakpoints?.tablet})`,
    `(min-width: ${breakpoints?.desktop})`,
  ]);
  return mediaQueries[0] && !mediaQueries[1];
};

export { useIsTabletSize };
